<template>
  <a-card :bordered="false">
    <Breadcrumb routeName="GoodsGroups" :toName="type==1?'编辑商品分组':'新建商品分组'"
                goPathName="商品分组"></Breadcrumb>
    <a-form-model :model="ruleForm" ref="ruleForm" :label-col="currentFormLayout.labelCol"
                  :wrapper-col="currentFormLayout.wrapperCol">
      <a-form-model-item label="分组名称" required>
        <a-input :disabled="ruleForm.groupPreset===1" style="max-width: 700px;" :maxLength="5"
                 v-model="ruleForm.groupName" placeholder="请输入"/>
      </a-form-model-item>
      <a-form-model-item
        label="分组图标"
        style="margin-bottom: 10px;height: 160px"
        :style="{height:ruleForm.imageList&&ruleForm.imageList.length>0?' 160px':'60'}"
      >
        <custom-upload-pro-images
          v-model="ruleForm.imageList"
          :multiple-selected="false"
          :showFlag="false"
          :image-style="{height:'28px',padding:0,width:'78px',border: 'none'}"
          :disabled="ruleForm.groupPreset===1"
          :maxCount="1"
          tips="温馨提示：图片上传尺寸为 78*28 上传图片格式为.jpg、.png、.jpeg"
          :draggableUpdate="false"></custom-upload-pro-images>
      </a-form-model-item>

      <a-form-model-item label="关联商品" required>
        <a-button @click="showModal">关联</a-button>
      </a-form-model-item>
      <a-form-model-item :wrapper-col="currentFormLayout.offsetCol">
        <custom-paging-dragging-list
          style="max-width: 700px;"
          ref="tableList"
          rowKey="groupProId"
          :columns="columns"
          :requestPromise="loadPromise"
          @draggable="onDraggable"
        >
          <template slot="index" slot-scope="rowItem">
            {{ rowItem.index + 1 }}
          </template>
          <div class="center-table" slot="action" slot-scope="rowItem">
            <a-popconfirm title="是否要移除当前商品？" @confirm="deleteProduct(rowItem.record)">
              <a>移除</a>
            </a-popconfirm>
          </div>
        </custom-paging-dragging-list>
      </a-form-model-item>
      <a-form-model-item label="状态">
        <a-radio-group v-model="ruleForm.groupStatus">
          <a-radio :value="1">显示</a-radio>
          <a-radio :value="0">隐藏</a-radio>
        </a-radio-group>
      </a-form-model-item>
      <a-form-model-item :wrapper-col="currentFormLayout.offsetCol">
        <a-button type="primary" :loading="submitLoading" @click="onSubmit">提交</a-button>
        <a-button style="margin-left: 20px" @click="goBack">取消</a-button>
      </a-form-model-item>
    </a-form-model>
    <a-modal title="关联商品" :visible="visible" :width="800" @cancel="visible = false" :footer="null">
      <a-form layout="inline">
        <a-form-item label="商品名称">
          <a-input v-model="queryParams.proName" placeholder="查询商品名称"></a-input>
        </a-form-item>
        <a-form-item label="商品ID">
          <a-input v-model="queryParams.proId" placeholder="查询商品ID"></a-input>
        </a-form-item>
        <a-form-item>
          <a-button type="primary" @click="$refs.table.refresh(true)">查询</a-button>
          <a-button type="primary" style="margin-left: 20px" @click="bindProduct">关联商品</a-button>
        </a-form-item>
      </a-form>
      <custom-page-table
        style="margin-top: 20px"
        ref="table"
        rowKey="proId"
        :columns="columnsGroup"
        :queryParams="queryParams"
        base-key="proUrl"
        params-path="public/getGoodsList"
        :rowSelection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
      >
        <span slot="proCatalogId" slot-scope="rowItem">
          {{ rowItem.record.proCatalogId|productTypeName }}
        </span>
      </custom-page-table>
    </a-modal>
  </a-card>
</template>

<script>
import Breadcrumb from '@/customComponents/Breadcrumb/Breadcrumb'
import CustomPagingDraggingList from '@/customComponents/CustomPagingDraggingList/CustomPagingDraggingList'
import ruleFormMixins from '@/utils/mixins/ruleFormMixins'
import CustomUploadProImages from '@/customComponents/CustomUploadProImages/CustomUploadProImages'

export default {
  name: 'CreateProductGroup',
  components: {
    Breadcrumb,
    CustomPagingDraggingList,
    CustomUploadProImages
  },
  mixins: [ruleFormMixins],
  data() {
    return {
      ruleForm: {
        groupName: '',
        groupStatus: 0,
        iconImg: []
      },
      merchantId: this.$store.getters.userInfo.merchantId,
      platformId: this.getPlatformConfig().platformId,
      queryParams: {
        shelfStatus: 1
      },
      columns: [
        {
          title: '排序',
          dataIndex: 'index',
          scopedSlots: { customRender: 'index' }
        },
        {
          title: '商品ID',
          dataIndex: 'proId'
        },
        {
          title: '商品类型',
          dataIndex: 'proTypeStr'
        },
        {
          title: '商品名称',
          dataIndex: 'proName',
          width: '30%'
        },
        {
          title: '操作',
          dataIndex: 'action',
          align: 'center',
          scopedSlots: { customRender: 'action' },
          fixed: 'right'
        }
      ],
      columnsGroup: [
        {
          title: '商品ID',
          dataIndex: 'proId'
        },
        {
          title: '商品类型',
          dataIndex: 'proCatalogId',
          scopedSlots: { customRender: 'proCatalogId' }
        },
        {
          title: '商品名称',
          dataIndex: 'proName',
          width: '40%'
        }
      ],
      loadPromise: params => this.getListPromise(params),
      visible: false,
      selectedRowKeys: [],
      groupId: null,
      type: this.$route.query.type,
      dataList: [],
      submitLoading: false,
      uploadFileUrl: this.getAppConfig().baseUrl + 'base/upload'//图片上传地址
    }
  },
  mounted() {
    if (this.$route.query.groupId) {
      this.getGroupInfo()
    }
  },
  methods: {
    getGroupInfo() {
      this.getHttpServices()
        .getProService()
        .get('proGroup/getProGroup?groupId=' + this.$route.query.groupId)
        .then(res => {
          this.ruleForm = {
            //groupName:res.groupName,
            //groupStatus:res.groupStatus,
            imageList: res.groupIcon ? [res.groupIcon] : [],
            ...res
          }
          this.groupId = res.groupId
          this.$refs.tableList.refresh(true)
        })
        .catch(err => {
          this.$message.error(err.msg)
        })
    },
    deleteProduct(record) {
      let groupId = this.$route.query.groupId ? this.$route.query.groupId : this.groupId
      this.getHttpServices()
        .getProService()
        .post('proGroup/delProGroupProduct', {
          groupProId: record.proId,
          groupId: groupId
        })
        .then(res => {
          this.$message.success('成功删除')
          this.$refs.tableList.refresh(true)
        })
        .catch(err => {
          this.$message.error(err.msg)
        })
    },
    checkForm() {
      if (!this.ruleForm.groupName) {
        this.$message.error('请输入分组名称')
        return false
      }
      if (this.dataList && this.dataList.length == 0) {
        this.$message.error('请选择关联商品')
        return false
      }
      return true
    },
    onSubmit() {
      if (this.checkForm()) {
        this.onSave(2)
      }
    },
    checkBind() {
      if (this.selectedRowKeys && this.selectedRowKeys.length == 0) {
        this.$message.error('请选择关联商品')
        return false
      }
      if (!this.groupId) {
        this.onSave(1)
        return false
      }
      return true
    },
    bindProduct() {
      if (this.checkBind()) {
        this.getHttpServices()
          .getProService()
          .post('proGroup/addProGroupProduct', {
            groupId: this.groupId,
            proIdList: this.selectedRowKeys
          })
          .then(res => {
            this.$message.success('成功关联')
            this.visible = false
            this.$refs.tableList.refresh(true)
          })
          .catch(err => {
            this.$message.error(err.msg)
          })
      }
    },
    onSave(type) {
      this.submitLoading = true
      const requestParams = {
        ...this.ruleForm,
        groupId: this.groupId,
        groupIcon: this.ruleForm.imageList && this.ruleForm.imageList.length > 0 ? this.ruleForm.imageList[0] : ''
      }
      delete requestParams.imageList
      this.getHttpServices()
        .getProService()
        .post('proGroup/editProGroup', requestParams)
        .then(res => {
          if (type == 1) {
            this.groupId = res
            this.getLogUtils().logWithTag('this.groupId', this.groupId)
            this.bindProduct()
          } else {
            let msg = this.type == 1 ? '成功编辑' : '成功保存'
            this.$message.success(msg)
            this.goBack()
          }
        }).catch(reason => this.showNetWorkErrorMessage(reason)).finally(() => this.submitLoading = false)
    },
    goBack() {
      this.$router.go(-1)
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
    },
    showModal() {
      this.selectedRowKeys = []
      this.visible = true
    },
    getListPromise(params) {
      if (this.groupId) {
        params.groupId = this.groupId
        return new Promise(((resolve, reject) => {
          this.getHttpServices().getProService().post('proGroup/findProGroupProduct', params)
            .then(res => {
              this.dataList = res.data
              resolve(res)
            })
            .catch(err => {
              reject(err)
            })
        }))
      } else {
        return Promise.resolve({
          pageSize: params.pageSize,
          pageNo: params.pageNo,
          totalCount: 0,
          totalPage: 0,
          data: []
        })
      }
    },
    onDraggable(params) {
      this.getLogUtils().logWithTag('==onDraggable排序==', params)
      let idList = new Array
      idList = params.dataList.map((item) => {
        return item.groupProId
      })
      this.getLogUtils().logWithTag('==idList==', idList)
      this.getHttpServices().getProService().post('proGroup/orderByProGroupProduct', {
        pageNum: params.pageNo,
        pageSize: params.pageSize,
        idList: idList
      }).then(res => {
        this.getLogUtils().logWithTag('==onDraggable==', res)
        this.$message.success('排序成功')
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    handleBeforeUploadImage(file) {
      this.getLogUtils().logWithTag('handleBeforeUploadImage', file)
      // 限制图片 格式、size、分辨率
      const isJPG = file.type === 'image/jpeg'
      const isJPEG = file.type === 'image/jpeg'
      const isGIF = file.type === 'image/gif'
      const isPNG = file.type === 'image/png'
      if (!(isJPG || isJPEG || isGIF || isPNG)) {
        this.$message.error('上传图片的格式不正确，不是JPG、JPEG、GIF、PNG')
        return false
      }
      const isLt2M = file.size / 1024 / 1024 < 3
      if (!isLt2M) {
        this.$message.error('上传的文件不能大于3M!')
      }
      return true
    }
  }
}
</script>

<style lang="less" scoped>
.center-table {
  text-align: center;
}
</style>
